import service from '@/services/integration/IntegrationService'

export var integrationMixin = {
  data: () => ({
    integrationData: {
      BASE_URL: '',
      PASSWORD: '',
      USERNAME: '',
      NOME_EMPRESA: '',
      DE_PARA: '',
      ITEM_TAXAENTREGA: null,
      ITEM_GENERICO: null,
      FILIAL: null,
      COLUNAS_EXPORTACAO: null,
    },
    integrationsList: [],
    integrationsHeader: [
      { text: 'ID User', value: 'USERNAME' },
      { text: 'Nome Integração', value: 'NOME_EMPRESA' },
      { text: 'Selecionado', value: 'selected' },
      { text: 'Ações', value: 'actions' },
    ],
  }),
  methods: {
    async getIntegrations(integrationName = '') {
      try {
        this.setLoadingDialogMessage('Carregando dados de integrações')
        this.showLoadingDialog(true)

        const payload =
          integrationName.length > 0
            ? { name: integrationName }
            : { todos: 'S' }

        let response = await service.getIntegration(payload)

        if (response.length == 0)
          this.$toasted.info(
            'Não foram encontradas integrações cadastradas [' +
              integrationName +
              '].'
          )
        this.integrationsList = response.data
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },
  },
}
